import {
  etakenya,
  imagepredictor,
  mfarusi,
  kenyagovtracker,
} from "../constants/images";

const Projects = () => {
  const projects = [
    {
      id: 1,
      src: etakenya,
      url: "https://etakenya.net",
      description:
        "EtaKenya is a user-friendly website designed to simplify the process of obtaining an Electronic Travel Authorization (eVisa) for Kenya. Tailored for foreigners, EtaKenya streamlines the application process with an intuitive interface, providing step-by-step guidance to ensure a hassle-free experience. The platform integrates essential features such as secure document upload, real-time status tracking, and comprehensive support to assist users at every stage. EtaKenya aims to enhance travel convenience, making Kenya accessible with ease and efficiency.",
    },
    {
      id: 2,
      src: imagepredictor,
      url: "https://ai-image-predictor.netlify.app/",
      description:
        "ImagePredictor is an innovative AI-powered website designed to provide detailed descriptions of images. This small but powerful project leverages advanced machine learning algorithms to analyze images and generate accurate and meaningful descriptions. Users can upload images to the platform, and ImagePredictor will swiftly process the visual data to produce descriptive text. This tool is particularly useful for improving accessibility, organizing photo collections, and enhancing user experience in various applications by providing context and insights into visual content.",
    },
    {
      id: 3,
      src: mfarusi,
      description:
        "Mfarusi Insurance Agency specializes in assisting clients with their insurance needs. The agency provides expert guidance on various insurance policies, helping clients make informed decisions to protect their assets and secure their future. With a focus on personalized service, Mfarusi Insurance Agency ensures that each client receives tailored advice and comprehensive support throughout the insurance process.",
    },
    {
      id: 4,
      src: kenyagovtracker,
      description:
        "KenyaGovTracker is an innovative platform dedicated to enhancing transparency, accountability, and citizen engagement within our government. As we found this initiative, We are committed to leveraging technology to empower citizens with access to crucial government information. Provide detailed insights into government fund allocations across 47 counties, track project progress, and foster citizen participation in governance.",
    },
  ];

  return (
    <>
      <div className="bg-gradient-to-b from-gray-800 to-black mt-10  w-full h-full"></div>
      <div
        name="projects"
        className="bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-screen"
      >
        <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
          <div className="pb-8">
            <p className="text-4xl font-bold inline border-b-4 border-gray-500">
              Projects
            </p>
            <p className="py-6">Check out some of my work here</p>
          </div>
          <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-8 px-12 sm:px-0">
            {projects.map((project) => (
              <div
                key={project.id}
                className="shadow-md shadow-gray-600 rounded-lg"
              >
                <img
                  src={project.src}
                  alt="Project"
                  className="rounded-md duration-200 hover:scale-105 bg-white"
                />
                <div className="p-4">
                  <p className="mb-4">{project.description}</p>
                  <div className="flex items-center justify-center">
                    {project.url ? (
                      <a
                        href={project.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full px-6 py-3 m-4 duration-200 hover:scale-105 bg-blue-600 text-white text-center rounded-md"
                      >
                        Visit Website
                      </a>
                    ) : (
                      <button
                        disabled
                        className="w-full px-6 py-3 m-4 duration-200 bg-gray-600 text-white text-center rounded-md cursor-not-allowed"
                      >
                        Coming Soon
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
